module.exports = __webpack_public_path__ + "static/media/z4.7649c7e5.JPG";